import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoConsecutiveSpaces]',
})
export class NoConsecutiveSpacesDirective {
  constructor() {}

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement) {
    const value = input.value;
    // Replace multiple consecutive spaces with a single space for pasted contents.
    input.value = value.replace(/\s+/g, ' ');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Check if the key pressed is space and if it would result in multiple consecutive spaces
    if (event.key === ' ' && (event.target as HTMLInputElement).value.endsWith(' ')) {
      event.preventDefault();
    }
  }
}
